export var version = {
  lib: '2.10099.2',
  product: '2.10099.2',
  supportedApiVersion: 2
};



// WEBPACK FOOTER //
// ./src/misc/Version.ts